<template>
  <div class="section-parameter" v-if="infos">
    <div class="col-left">
      <h2>{{ $t('settings.languages.title') }}</h2>
    </div>
    <div class="col-right">
      <div class="form-group" v-click-outside="onClickOutside">
        <div class="language" v-for="(language, index) in languagesAvailable" :key="index">
          <div class="title">
            <span>{{ $t('settings.languages.' + language.lang ) }}</span>
            <span class="tag enable" v-if="isEnable(language)">enable</span>
            <span class="tag disable" v-else>disable</span>
            <span class="tag default" v-if="isDefault(language)">default</span>
          </div>
          <div class="actions">
            <div class="group-actions">
              <div class="trigger" @click="toggleOpen(language)">
                <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
              </div>

              <transition name="bounce">
                <div v-if="isOpened === language.lang" class="group-actions-menu box">
                  <ul>
                    <li  v-if="!isDefault(language) && isEnable(language)">
                      <span @click="updateLanguagues(language)">Set Default</span>
                    </li>
                    <li v-if="isEnable(language)">
                      <span @click="removeLanguagues(language)">Disable</span>
                    </li>
                    <li v-else>
                      <span @click="addLanguagues(language)">Enable</span>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Avatar from 'vue-avatar'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    Avatar
  },
  data () {
    return {
      infos: [],
      isOpened: null,
      languagesAvailable: [
        {
          lang: 'fr'
        },
        {
          lang: 'en'
        },
        {
          lang: 'es'
        },
        {
          lang: 'ro'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    })
  },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  methods: {
    ...mapActions('account', ['addLang', 'updateLang', 'removeLang']),

    init () {
      if (this.site) {
        this.site.languages.forEach((lang) => {
          this.infos.push(Object.assign({}, lang))
        })
      }
    },
    isDefault (language) {
      let response = false
      if (this.infos) {
        this.infos.forEach((lang) => {
          if (lang.lang === language.lang && lang.default === 1) {
            response = true
          }
        })
      }

      return response
    },
    isEnable (language) {
      let response = false
      if (this.infos) {
        this.infos.forEach((lang) => {
          if (lang.lang === language.lang) {
            response = true
          }
        })
      }

      return response
    },
    toggleOpen (language) {
      if (this.isOpened === language.lang) {
        this.isOpened = null
      } else {
        this.isOpened = language.lang
      }
    },
    onClickOutside () {
      this.isOpened = false
    },
    addLanguagues (lang) {
      this.addLang({site: this.site, languages: {default: 0, lang: lang.lang}}).then(() => {
        this.$notify({title: 'Success', message: this.$root.$t('notifications.settings.edited'), type: 'success'})
      }).catch((e) => {
        this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.unknown') })
      })
    },
    updateLanguagues (lang) {
      this.updateLang({site: this.site, languages: {default: 1, lang: lang.lang}}).then(() => {
        this.$notify({title: 'Success', message: this.$root.$t('notifications.settings.edited'), type: 'success'})
      }).catch((e) => {
        this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.unknown') })
      })
    },
    removeLanguagues (lang) {
      this.removeLang({site: this.site, languages: {default: 0, lang: lang.lang}}).then(() => {
        this.$notify({title: 'Success', message: this.$root.$t('notifications.settings.edited'), type: 'success'})
      }).catch((e) => {
        this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.unknown') })
      })
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang="scss" scopped>

    .language {
        display:grid;
        font-size: 14px;
        font-weight: 600;
        grid-template-columns:1fr 80px;
        align-items: center;
        grid-gap: 24px;
        padding-bottom: 8px;
        margin-bottom: 8px;
        border-bottom: 1px solid #dedede;

        .tag {
            font-size: 13px;
            font-weight: 400;
            background: #dedede;

            &.enable {
                background: #3FC380;
            }
            &.disable {
                background: #6C7A89;
            }
            &.default {
                background: #446CB3;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/settings/settings_languages.vue